import { Injectable } from "@angular/core";
import { NetworkService } from "../../shared/network.service";

@Injectable({
  providedIn: "root",
})
export class DashboardService {
  constructor(private networkservice: NetworkService) {}

  dashboardApi() {
    return this.networkservice.get("api/dashboard", null, null, "bearer");
  }
  getPaymentApi(query: any) {
    return this.networkservice.get("api/order/invoice?" + query, null, null, "bearer");
  }
  getOrderApi(query: any) {
    return this.networkservice.get("api/order?" + query, null, null, "bearer");
  }
  addSlot(body:any) {
    return this.networkservice.post("api/slot",body,null,'bearer')
  }
  getSlots() {
    return this.networkservice.get("api/slot", null, null, "bearer");
  }
  getUserCountsApi() {
    return this.networkservice.get("api/dashboard/user-counts", null, null, "bearer");
  }
}
